import Dialog, {DialogCloseEventArgs} from "../../1. Core/Controls/Dialog/Dialog";
import NP from "../../1. Core/NP";
import Delegate from "../../1. Core/Delegate";
import Control from "../../1. Core/Control";
import TextField from "../../1. Core/Controls/TextField/TextField";
import {ServerAPI} from "../../1. Core/ServerAPI";
import Select from "../../1. Core/Controls/Select/Select";
import {Role} from "../../1. Core/Types";

export default class CreateUserDlg extends Dialog {
	public EvUserCreated: Delegate;

	private _emailTb: Control;
	private _passwTextBox: Control;
	private _type: Select;

	constructor(settings?: object)
	{
		super(settings);
	}

	_initFields(settings: object)
	{
		this.EvUserCreated = new Delegate();

		super._initFields(settings);
		this._Caption = 'Create new user';
		this._ShowHeader = true;
		this.EvOkButtonClick.add(this._onCreateUserDlgOkButtonClick, this);
	}

	_render()
	{
		super._render();

		this.addClass('app-list-group');

		this._emailTb = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString("Email")
		});

		this._passwTextBox = new TextField({
			ParentNode: this._contentNode,
			FloatingLabel: NP.RM.getString("Password")
		});

		this._type = new Select({
			FloatingLabel: NP.RM.getString("Type"),
			ParentNode: this._contentNode,
			Items: [
				{Content: 'Admin', Value: Role.admin},
				{Content: 'User', Value: Role.User},
				{Content: 'Judge', Value: Role.Judge},
				//{Content: 'Fantasy Gamer', Value: 3}
			],
			Value: Role.User
		})

	}

	async _onCreateUserDlgOkButtonClick(sender: object, args: DialogCloseEventArgs)
	{
		args.IsCancelClose = true;
		if (this._emailTb.getValue() && this._passwTextBox.getValue())
		{
			await ServerAPI.put("/users", {
				email: this._emailTb.getValue(),
				password: this._passwTextBox.getValue(),
				role: this._type.getValue()
			})
			this.EvUserCreated.fire(this);
			this.hide();
		}
	}
}